import React, { useEffect, useMemo, useRef } from "react";
import GridItem from "../Grid/GridItem.js";
import Adsense from "../../Adsense/Adsense.js";
import { useMail } from "../../../../contexts/mailContext/mailContext.js";
import { useMailView } from "../../../../contexts/mailViewContext/mailViewContext.js";
import { useComments } from "../../../../contexts/commentsContext/commentsContext.js";
import FeedItem from "./FeedItem.js";
import FolderDivider from "../CoolGrid/FolderDivider.js";
import useHideBanners from "../../Adsense/useHideBanners.js";

const MobleGridWithAds = ({ filesList }) => {
  const lastFolderIndex = useRef();
  const foldersList = useRef([]);
  const shouldRenderNext = useRef(null);

  return useMemo(
    () =>
      filesList.map((item, i) => {
        if (item.folder) {
          lastFolderIndex.current = i;
          !foldersList.current.includes(item.folder) &&
            foldersList.current.push(item.folder);
          return (
            <div className="col-12" key={item.folder + i}>
              <FolderDivider folderId={item.folder} />
            </div>
          );
        }

        /**
         * SETTING REAL NUMBER OF FILE WITHIN GRID
         * IF EXIST FOLDERS BEFORE IT WILL IGNORE IT
         * TO DETECT EXATCLY 36-s FILE AND IGNORE FOLDERS
         */
        const realIndex =
          i > lastFolderIndex.current
            ? i - foldersList.current.length + 1
            : i + 1;

        /**
         * CHECKING IF WE NEED TO RENDER ITEM COS PREVIOUS ROW WAST FINISHED
         */
        if (shouldRenderNext.current) {
          shouldRenderNext.current = false;
          return (
            <React.Fragment key={item + i}>
              <div className="col-4" key={item + i}>
                <GridItem itemId={item} />
              </div>
              <div className="col-12 mobile-ads-feed" key={"ad" + i}>
                <Adsense bannerPosition="download-feed-responsive" />
              </div>
            </React.Fragment>
          );
        }

        /**
         * CHECKING IF INDEX OF ITEM IS SUITES OUR REQUIREMENTS OF POSITIONING
         */
        if (
          realIndex === 36 ||
          ((realIndex - 36) % 42 === 0 && realIndex !== 0)
        ) {
          /**
           * DIFFERENT POSITIONING IN CASE THAT FOLDER DEVIDER EXIST BEFORE ITEM
           */
          if (lastFolderIndex.current && i > lastFolderIndex.current) {
            /**
             * CHECKING IF NUMBER IS NOT DIVISIONING TO 3(QUANTITY OF ITEM IN ONE ROW)
             */
            if ((i - lastFolderIndex.current) % 3 !== 0) {
              /**
               * THIS CASE WHEN PREV ITEM WAS SUITABLE FOR US
               */
              return (i - 1 - lastFolderIndex.current) % 3 === 0 ? (
                <React.Fragment key={item + i}>
                  <div className="col-12 mobile-ads-feed" key={"ad" + i}>
                    <Adsense bannerPosition="download-feed-responsive" />
                  </div>
                  <div className="col-4" key={item + i}>
                    <GridItem itemId={item} />
                  </div>
                </React.Fragment>
              ) : (
                /**
                 * THIS CASE WHEN NEXT ITEM WILL BE SUITABLE FOR US
                 */
                (() => {
                  shouldRenderNext.current = true;
                  return (
                    <div className="col-4" key={item + i}>
                      <GridItem itemId={item} />
                    </div>
                  );
                })()
              );
            } else {
              /**
               * THIS CASE IF NUMBER IS DIVISIONING TO 3 AND WE CAN TYPICAL SET AD
               */
              return (
                <React.Fragment key={item + i}>
                  <div className="col-4" key={item + i}>
                    <GridItem itemId={item} />
                  </div>
                  <div className="col-12 mobile-ads-feed" key={"ad" + i}>
                    <Adsense bannerPosition="download-feed-responsive" />
                  </div>
                </React.Fragment>
              );
            }
          } else {
            /**
             * THIS CASE WHEN MAIL WITHOUT FOLDERS
             */
            return (
              <React.Fragment key={item + i}>
                <div className="col-4" key={item + i}>
                  <GridItem itemId={item} />
                </div>
                <div className="col-12 mobile-ads-feed" key={"ad" + i}>
                  <Adsense bannerPosition="download-feed-responsive" />
                </div>
              </React.Fragment>
            );
          }
        }
        return (
          <div className="col-4" key={item + i}>
            <GridItem itemId={item} />
          </div>
        );
      }),
    [filesList]
  );
};

const MobileFeedWithAds = ({ filesList }) => {
  const foldersList = useRef([]);

  return filesList.map((item, i) => {
    if (item.folder) {
      !foldersList.current.includes(item.folder) &&
        foldersList.current.push(item.folder);

      return (
        <div className="feed-item" key={item.folder + "folder"}>
          <FolderDivider folderId={item.folder} />
        </div>
      );
    }

    const realIndex = i - foldersList.current.length + 1;
    if (realIndex === 6 || ((realIndex - 6) % 12 === 0 && realIndex !== 0)) {
      return (
        <React.Fragment key={item + i}>
          <FeedItem itemId={item} key={item} />
          <div className="mobile-ads-feed" key={"ad" + i}>
            <Adsense bannerPosition="download-feed-responsive" />
          </div>
        </React.Fragment>
      );
    }

    return <FeedItem itemId={item} key={item} />;
  });
};

const MobileGrid = () => {
  const { fetchCommentsData } = useComments();
  const { getMailId, getFilesList } = useMail();
  const { getMobileGridView } = useMailView();

  const userIsPro = useHideBanners();

  useEffect(() => {
    fetchCommentsData(getMailId());
  }, [getMailId()]);

  return (
    <>
      {getMobileGridView() ? (
        <div className="mobile-grid-container">
          <div className="row">
            {userIsPro ? (
              getFilesList().map((item, i) => {
                return item.folder ? (
                  <div className="col-12" key={item.folder + i}>
                    <FolderDivider folderId={item.folder} />
                  </div>
                ) : (
                  <div className="col-4" key={item + i}>
                    <GridItem itemId={item} />
                  </div>
                );
              })
            ) : (
              <MobleGridWithAds filesList={getFilesList()} />
            )}
          </div>
        </div>
      ) : (
        <div className="mobile-feed-container">
          {userIsPro ? (
            getFilesList().map((item, i) => {
              return item.folder ? (
                <div className="feed-item" key={item.folder + "folder"}>
                  <FolderDivider folderId={item.folder} />
                </div>
              ) : (
                <FeedItem itemId={item} key={item + i} />
              );
            })
          ) : (
            <MobileFeedWithAds filesList={getFilesList()} />
          )}
        </div>
      )}
    </>
  );
};

export default MobileGrid;
